import { render } from "./BizAnnouncements.vue?vue&type=template&id=89beb956&scoped=true"
import script from "./BizAnnouncements.vue?vue&type=script&lang=js"
export * from "./BizAnnouncements.vue?vue&type=script&lang=js"

import "./BizAnnouncements.vue?vue&type=style&index=0&id=89beb956&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89beb956"]])

export default __exports__